// 画面レイアウト
import header from '@/components/organisms/TheHeader'
import footer from '@/components/organisms/TheFooter'
import sidebar from '@/components/organisms/TheSidebar'

// ------------------------------------------------------------
// メンテナンス画面
// ------------------------------------------------------------
// メンテナンス画面：登録待ちの名刺
import Queued from '@/components/pages/maintenance/queued-bcards/Index'
// メンテナンス画面：画像未登録名刺
import Noimage from '@/components/pages/maintenance/noimage-bcards/Index'
// メンテナンス画面：読取不能名刺
import ReadErr from '@/components/pages/maintenance/readerr-bcards/Index'
// メンテナンス画面：名寄せ
import MergePersons from '@/components/pages/maintenance/duplicated-persons/Index'
import MergePersonsList from '@/components/pages/maintenance/duplicated-persons/List'
import MergePersonsDetail from '@/components/pages/maintenance/duplicated-persons/Detail'

// ------------------------------------------------------------
// メンテナンス画面
// ------------------------------------------------------------
export default [
  // 登録待ちの名刺
  {
    path: '/queued-bcards',
    name: 'queued',
    components: {
      header,
      sidebar,
      footer,
      content: Queued
    },
    children: [
      // 名刺モーダルを開くためのパス
      {
        path: ':sid_person',
        name: 'queued-detail',
        children: [
          {
            path: ':sid_bcard',
            name: 'queued-history'
          }
        ]
      }
    ]
  },
  // 画像未登録名刺
  {
    path: '/noimage-bcards',
    name: 'noimage',
    components: {
      header,
      sidebar,
      footer,
      content: Noimage
    },
    children: [
      // 名刺モーダルを開くためのパス
      {
        path: ':sid_person',
        name: 'noimage-detail',
        children: [
          {
            path: ':sid_bcard',
            name: 'noimage-history'
          }
        ]
      }
    ]
  },
  // 読取不能名刺
  {
    path: '/readerr-bcards',
    name: 'readerr',
    components: {
      header,
      sidebar,
      footer,
      content: ReadErr
    },
    children: [
      // 名刺モーダルを開くためのパス
      {
        path: ':sid_person',
        name: 'readerr-detail',
        children: [
          {
            path: ':sid_bcard',
            name: 'readerr-history'
          }
        ]
      }
    ]
  },
  // 名寄せ候補名刺
  {
    path: '/merge-persons',
    components: {
      header,
      sidebar,
      footer,
      content: MergePersons
    },
    children: [
      {
        path: '',
        name: 'merge-persons-list',
        component: MergePersonsList
      },
      // 名寄せ
      {
        path: '/merge-persons/:id',
        name: 'merge-persons-detail',
        component: MergePersonsDetail,
        props: true // $route.params.idをpropsに引き渡す
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/routes.maintenance.js